<!-- =========================================================================================
  File Name: Mail Server.vue
  Description: Mail Server page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

    <div id="page-mail-server-list" class="vx-card p-6">
      <!-- Searchs-->
      <vx-card ref="filterCard" class="mail-server-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
          <div class="vx-row">
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">受信メール名</label>
            <vs-input class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" placeholder="受信メール名（部分一致）"  :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="receiveusernameSearch"/>
          </div>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/2 w-full flex flex-wrap items-end justify-end div-search-bnt">
              <vs-button icon="search" @click="pageNumber = 1; searchMailWithOrder(); ids = []" class="search_icon mr-6 sm:mr-3">検索 </vs-button>
          </div>
      </vx-card>


     
        <!-- Title and Buttons Action -->
        <div class="text-title">
          <span>メールサーバー一覧</span>
        </div>
        <vs-row class="pl-2">
          <vs-col class="flex flex-wrap items-center justify-start pl-6" vs-w="3">
            <span class="pr-2">表示件数:</span>
            <div class="vx-col md:w-24 w-full">
              <v-select class="sm:mr-4 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" :options="paginationOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="paginationPageSize">
                <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
              </v-select>
            </div>
          </vs-col>
          <vs-col class="flex flex-wrap items-center md:justify-end justify-evenly" vs-w="9">
            <vs-button :disabled="ids.length > 0 ? false:true" color="danger" icon="delete" @click="activeDelete = true;delete_one_record = false">削除</vs-button>
            <vs-button color="success" class="icon-custom"  @click="setUpCreate">
              <EmailAddIcon />
              登録</vs-button>
          </vs-col>
        </vs-row>
      <!--Pop delete mail server -->
      <vs-popup id="dialogDelete" title="メールサーバー情報の削除" :active.sync="activeDelete" button-close-hidden>
        <div v-if= "delete_one_record  == false">
          <span>
            <strong>選択したサーバー情報を削除します</strong>
          </span>
        </div>
        <div v-else>
          <span>
          <strong>このサーバー情報を削除します</strong>
          </span>
          <div>
            <vs-row>
                  <vs-col class="flex items-center" vs-w="4">
                    <span class="pt-2">メールサーバ名 </span>
                  </vs-col>
                  <vs-col vs-w="8">
                    <vs-row>
                      <span class="pt-2">{{mail_srv_name}} </span>
                    </vs-row>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col class="flex items-center" vs-w="4">
                    <span class="pt-2">受信メールアドレス </span>
                  </vs-col>
                  <vs-col vs-w="8">
                    <vs-row>
                      <span class="pt-2">{{receive_user_name}} </span>
                    </vs-row>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col class="flex items-center" vs-w="4">
                    <span class="pt-2">送信メールアドレス </span>
                  </vs-col>
                  <vs-col vs-w="8">
                    <vs-row>
                      <span class="pt-2">{{sent_user_name}} </span>
                    </vs-row>
                  </vs-col>
                </vs-row>
                
          </div>
        </div>
        <div class="flex justify-end mt-4">
            <vs-button @click="confirmDelete" icon="delete" color="danger" class="mx-2">削除</vs-button>
            <vs-button @click="activeDelete = false" icon="cancel" color="lightgrey">キャンセル</vs-button>
        </div>
      </vs-popup>

      <!-- Create and Edit Dialog -->
      <vs-popup id="dialogUpdate" :title="title" :active.sync="activePopup" button-close-hidden>
        <div>
          <div>
            <vx-card :title="title == 'メールサーバー情報登録' ? 'メールサーバーの詳細' : ''"
              card-background ="rgb(240, 238, 241)"  height="420px" class="pb-2 pt-0 card-mail-serve" 
              :class="title == 'メールサーバー情報更新' ? '' : 'checkTabOne'" >
              <vs-tabs v-model="checkTab">
                <vs-tab :class="title == 'メールサーバー情報更新'?'px-0 pt-6':''" label="全般">
                  <div v-if="title == 'メールサーバー情報更新'" class="pt-2 py-4"><h4 class="">メールサーバーの詳細</h4></div>
                  <div>
                    <!-- mail server name -->
                    <vs-row>
                      <vs-col class="flex items-center" vs-w="4">
                        <span class="pt-2">メールサーバ名<span style="color: red" >*</span></span>
                      </vs-col>
                      <vs-col vs-w="8">
                        <vs-row>
                          <vs-input  v-validate.immediate="'required'" name="メールサーバ名" maxlength="56" v-model="mail_srv_name" class="w-full"/>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-row v-show="errors.first('メールサーバ名')">
                      <vs-col vs-offset="4">
                        <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("メールサーバ名") | convertError }}</span>
                      </vs-col>
                    </vs-row>
                    <!-- server protocol -->
                    <vs-row class="mt-3">
                      <vs-col class="flex items-center" vs-w="4">
                        <span class="pt-2">プロトコル設定 <span style="color: red" >*</span></span>
                      </vs-col>
                      <vs-col vs-w="8">
                        <vs-row>
                          <div v-for="(item,index) in protcolOptions" :key="index">
                          <div class="mr-3 mt-1">
                            <input type="radio" v-model="svr_protcol" :value="item" class="mr-1" style="position: relative; top: 2px"/>
                            <span>{{item}}</span>
                          </div>
                          </div>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <!-- receive server name -->
                    <vs-row class="mt-3">
                      <vs-col class="flex items-center" vs-w="4">
                        <span class="pt-2">受信メールサーバ名 <span style="color: red" >*</span></span>
                      </vs-col>
                      <vs-col vs-w="8">
                        <vs-row>
                          <vs-input  v-validate.immediate="'required'" maxlength="256" name="受信メールサーバ名 " v-model="receive_server_name" class="w-full"/>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-row v-show="errors.first('受信メールサーバ名 ')">
                      <vs-col vs-offset="4">
                        <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("受信メールサーバ名 ") | convertError }}</span>
                      </vs-col>
                    </vs-row>
                    <!-- receive user name -->
                    <vs-row class="mt-3">
                      <vs-col class="flex items-center" vs-w="4">
                        <span class="pt-2">受信メールアドレス<span style="color: red" >*</span></span>
                      </vs-col>
                      <vs-col vs-w="8">
                        <vs-row>
                          <vs-input  v-validate.immediate="'required|email|override-email'" maxlength="256" name="受信メールアドレス" v-model="receive_user_name" class="w-full"/>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-row v-show="errors.first('受信メールアドレス')">
                      <vs-col vs-offset="4">
                        <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("受信メールアドレス") | convertError }}</span>
                      </vs-col>
                    </vs-row>
                    <!-- receive password -->
                    <vs-row class="mt-3">
                      <vs-col class="flex items-center" vs-w="4">
                        <span class="pt-2">受信メールパスワード <span style="color: red" >*</span></span>
                      </vs-col>
                      <vs-col vs-w="8">
                        <vs-row>
                          <vs-input type="password"  v-validate.immediate="'required'" maxlength="512" name="受信メールパスワード " v-model="receive_password" class="w-full"/>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-row v-show="errors.first('受信メールパスワード ')">
                      <vs-col vs-offset="4">
                        <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("受信メールパスワード ") | convertError }}</span>
                      </vs-col>
                    </vs-row>
                    <!-- receive port -->
                    <vs-row class="mt-3">
                      <vs-col class="flex items-center" vs-w="4">
                        <span class="pt-2">受信メールポート番号 <span style="color: red" >*</span></span>
                      </vs-col>
                      <vs-col vs-w="8">
                        <vs-row>
                          <vs-input type="number" v-validate.immediate="'required|port'"  name="受信メールポート番号 " v-model="receive_port" class="w-full"/>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-row v-show="errors.first('受信メールポート番号 ')">
                      <vs-col vs-offset="4">
                        <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("受信メールポート番号 ") | convertError }}</span>
                      </vs-col>
                    </vs-row>
                    <!-- receive security -->
                    <vs-row class="mt-3">
                      <vs-col class="flex items-center" vs-w="4">
                        <span class="pt-2">受信メール暗号接続設定<span style="color: red" >*</span></span>
                      </vs-col>
                      <vs-col vs-w="8">
                        <vs-row>
                          <div v-for="(item,index) in securityOptions" :key="index">
                          <div class="mr-3 mt-1">
                            <input type="radio" v-model="receive_security" :value="item" class="mr-1" style="position: relative; top: 2px"/>
                            <span>{{item}}</span>
                          </div>
                          </div>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <!-- receive spa -->
                    <vs-row class="mt-3">
                      <vs-col class="flex items-center" vs-w="4">
                        <span class="pt-2">受信メールSPA設定<span style="color: red" >*</span></span>
                      </vs-col>
                      <vs-col vs-w="8">
                        <vs-row>
                          <div v-for="(item,index) in spaOptions" :key="index">
                          <div class="mr-3 mt-1">
                            <input type="radio" v-model="receive_spa" :value="item" class="mr-1" style="position: relative; top: 2px"/>
                            <span>{{item}}</span>
                          </div>
                          </div>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-row class="mt-3">
                      <vs-col class="flex items-center" vs-w="4">
                        <span class="pt-2">受信メールSMTP認証<span style="color: red" >*</span></span>
                      </vs-col>
                      <vs-col vs-w="8">
                        <vs-row>
                          <div v-for="(item,index) in stateOptions" :key="index">
                          <div class="mr-3 mt-1">
                            <input type="radio" v-model="receive_smtp_auth" :value="item" class="mr-1" style="position: relative; top: 2px"/>
                            <span>{{item}}</span>
                          </div>
                          </div>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <!-- sent server name -->
                    <vs-row class="mt-3">
                      <vs-col class="flex items-center" vs-w="4">
                        <span class="pt-2">送信メールサーバ名<span style="color: red" >*</span></span>
                      </vs-col>
                      <vs-col vs-w="8">
                        <vs-row>
                          <vs-input  v-validate.immediate="'required'" maxlength="256" name="送信メールサーバ名" v-model="sent_server_name" class="w-full"/>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-row v-show="errors.first('送信メールサーバ名')">
                      <vs-col vs-offset="4">
                        <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("送信メールサーバ名") | convertError }}</span>
                      </vs-col>
                    </vs-row>
                    <!-- sent user name -->
                    <vs-row class="mt-3">
                      <vs-col class="flex items-center" vs-w="4">
                        <span class="pt-2">送信メールアドレス <span style="color: red" >*</span></span>
                      </vs-col>
                      <vs-col vs-w="8">
                        <vs-row>
                          <vs-input  v-validate.immediate="'required|email|override-email'" maxlength="256" name="送信メールアドレス " v-model="sent_user_name" class="w-full"/>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-row v-show="errors.first('送信メールアドレス ')">
                      <vs-col vs-offset="4">
                        <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("送信メールアドレス ") | convertError }}</span>
                      </vs-col>
                    </vs-row>
                    <!-- sent password -->
                    <vs-row class="mt-3">
                      <vs-col class="flex items-center" vs-w="4">
                        <span class="pt-2">送信メールパスワード<span style="color: red" >*</span></span>
                      </vs-col>
                      <vs-col vs-w="8">
                        <vs-row>
                          <vs-input type="password" v-validate.immediate="'required'" maxlength="512" name="送信メールパスワード" v-model="sent_password" class="w-full"/>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-row v-show="errors.first('送信メールパスワード')">
                      <vs-col vs-offset="4">
                        <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("送信メールパスワード") | convertError }}</span>
                      </vs-col>
                    </vs-row>
                    <!-- sent port -->
                    <vs-row class="mt-3">
                      <vs-col class="flex items-center" vs-w="4">
                        <span class="pt-2">送信メールポート番号<span style="color: red" >*</span></span>
                      </vs-col>
                      <vs-col vs-w="8">
                        <vs-row>
                          <vs-input type="number"  v-validate.immediate="'required|port'"  name="送信メールポート番号" v-model="sent_port" class="w-full"/>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-row v-show="errors.first('送信メールポート番号')">
                      <vs-col vs-offset="4">
                        <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("送信メールポート番号") | convertError }}</span>
                      </vs-col>
                    </vs-row>
                    <!-- sent security -->
                    <vs-row class="mt-3">
                      <vs-col class="flex items-center" vs-w="4">
                        <span class="pt-2">送信メール暗号接続設定<span style="color: red" >*</span></span>
                      </vs-col>
                      <vs-col vs-w="8">
                        <vs-row>
                          <div v-for="(item,index) in securityOptions" :key="index">
                          <div class="mr-3 mt-1">
                            <input type="radio" v-model="sent_security" :value="item" class="mr-1" style="position: relative; top: 2px"/>
                            <span>{{item}}</span>
                          </div>
                          </div>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <!-- sent spa -->
                    <vs-row class="mt-3">
                      <vs-col class="flex items-center" vs-w="4">
                        <span class="pt-2">送信メールSPA設定 <span style="color: red" >*</span></span>
                      </vs-col>
                      <vs-col vs-w="8">
                        <vs-row>
                          <div v-for="(item,index) in spaOptions" :key="index">
                          <div class="mr-3 mt-1">
                            <input type="radio" v-model="sent_spa" :value="item" class="mr-1" style="position: relative; top: 2px"/>
                            <span>{{item}}</span>
                          </div>
                          </div>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-row class="mt-3">
                      <vs-col class="flex items-center" vs-w="4">
                        <span class="pt-2">送信メールSMTP認証<span style="color: red" >*</span></span>
                      </vs-col>
                      <vs-col vs-w="8">
                        <vs-row>
                          <div v-for="(item,index) in stateOptions" :key="index">
                          <div class="mr-3 mt-1">
                            <input type="radio" v-model="sent_smtp_auth" :value="item" class="mr-1" style="position: relative; top: 2px"/>
                            <span>{{item}}</span>
                          </div>
                          </div>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                    <vs-row class="mt-3">
                      <vs-col class="flex items-center" vs-w="4">
                        <span class="pt-2">状態<span style="color: red" >*</span></span>
                      </vs-col>
                      <vs-col vs-w="8">
                        <vs-row>
                          <div v-for="(item,index) in optionsStateFlg" :key="index">
                          <div class="mr-3 mt-1">
                            <input type="radio" v-model="state_flg" :value="item" class="mr-1" style="position: relative; top: 2px"/>
                            <span>{{item}}</span>
                          </div>
                          </div>
                        </vs-row>
                      </vs-col>
                    </vs-row>
                  </div>
                </vs-tab>
                <vs-tab class="pt-6 pr-0" label="転送">
                  <span v-if="mail_server_notification.length == 0">データがありません</span>
                    <vs-row v-for="(mailServer,index) in mail_server_notification" :key="index">
                      <vs-col vs-w="12" class="flex" :class="index == (mail_server_notification.length - 1) ? 'mb-2' : errors.first(`通知メールアドレス-番号 ${index + 1} `) ? 'mb-2' : 'mb-4'">
                        <vs-input  
                          v-validate.immediate="{ required: true, email: true, override_email: true, unique_email: {index, listEmail: mail_server_notification.map(item => item.name )} }" 
                          maxlength="256" 
                          :name="`通知メールアドレス-番号 ${index + 1} `" 
                          v-model="mailServer.name" 
                          class="w-full pr-3"
                          @focus="handleFocusNotification(index)" 
                          @blur="handleBlurNotification(index)" 
                        />
                        <vs-button  @click="removeMailServerNotification(index)" class="vs-button-customs round" v-if="mail_server_notification.length > 1" icon="remove" color="lightgrey"></vs-button>
                        <vs-button  @click="addMailServerNotification" :disabled="!validateForm && submited" class="vs-button-customs round" v-if="index == (mail_server_notification.length - 1)" icon="add" color="success"></vs-button>
                      </vs-col>
                      <vs-col v-if="mail_server_erros == index ? mail_server_notification.length == 1 ? mailServer.name.length > 0 : true : false" v-show="errors.first(`通知メールアドレス-番号 ${index + 1} `)">
                        <span v-show="submited" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first(`通知メールアドレス-番号 ${index + 1} `) | convertError }}</span>
                      </vs-col>
                    </vs-row>
                </vs-tab>
                <vs-tab class="pt-6 pr-0" label="SV">
                  <vs-row class="mt-3">
                    <vs-col class="flex justify-center items-center" vs-w="3">
                      <span class="pt-2">SV連携</span>
                    </vs-col>
                    <vs-col vs-w="9">
                      <vs-row class="flex justify-start items-center pl-10">
                        <div v-for="(item,index) in stateOptions" :key="index">
                          <div class="mr-3 flex justify-start items-center mt-1 pl-2">
                            <input type="radio" v-model="is_sv_linked" :value="item" class="mr-1 mt-1"/>
                            <span class="mt-1">{{item}}</span>
                          </div>
                        </div>
                      </vs-row>
                    </vs-col>
                  </vs-row>
                </vs-tab>
              </vs-tabs>
            </vx-card>
          </div>
          <div v-if="checkTab == 0">
            <span v-if = "statusConnection == true " style = "color:green; white-space: pre-wrap;" class="pt-4">{{messageConnection}}</span>
            <span v-if = "statusConnection == false " style = "color:red; white-space: pre-wrap;" class="pt-4">{{messageConnection}}</span>
            <div style="display: flex; justify-content: flex-end" class="pt-4">
              <vs-button @click="actionTestConnection" color="warning" class="vs-button-customs">接続確認</vs-button>
              <vs-button v-if="title == 'メールサーバー情報更新'" @click="actionUpdate" :disabled="!validateForm && submited" icon="save" color="success" class="vs-button-customs">更新</vs-button>
              <vs-button v-else @click="actionCreate" :disabled="!validateForm && submited" color="success" class="vs-button-customs"><EmailAddIcon />
                登録</vs-button>
              <vs-button @click="activePopup = false" icon="cancel" color="lightgrey" class="vs-button-customs">閉じる</vs-button>
            </div>
          </div>
          <div v-else>
            <div class="flex justify-end pt-4">
              <vs-button @click="actionUpdate" class="vs-button-customs" icon="save" color="success" >更新</vs-button>
              <vs-button @click="activePopup = false" class="vs-button-customs" icon="cancel" color="lightgrey">閉じる</vs-button>
            </div>
          </div>
        </div>
      </vs-popup>

      <!-- AgGrid Table -->
      <ag-grid-vue
        id="myGrid"
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table database"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="mailsData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :domLayout="domLayout"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        @selection-changed="onSelectionChanged"
        @sortChanged="onSortChangedEvent"
        :overlayNoRowsTemplate="noRowsTemplate"
        :detailRowAutoHeight="true"
      >
      </ag-grid-vue>

      <div style="position: relative">
      <!-- ITEMS PER PAGE -->
        <div>
            <div class="flex items-center justify-between">
              <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
            </div>
        </div>
      <!-- pagination -->
        <vs-pagination
            :total="totalPages"
            v-model="currentPage"
            :max="7"
            class="pr-10 pt-10"
            />
    </div>
  </div>

</template>

<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import { AgGridVue } from 'ag-grid-vue'
import vSelect       from 'vue-select'
import EventBus      from '../../../EventBus'
import {mapActions, mapGetters} from 'vuex'
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

// Cell Renderer
import CellRendererActions from '@/components/cell-renderer/CellRendererActions.vue'
import EmailAddIcon from "../../icons/EmailAddIcon";

export default {
  components: {
    EmailAddIcon,
    AgGridVue,
    vSelect,
    // Cell Renderer
    CellRendererActions,
    flatPickr
  },
  data () {
    return {
      activePopup:     false,
      activeDelete:    false,
      submited:        false,
      title:           '',
      id:              null,
      ids:             [],
      mail_srv_name:       null,
      svr_protcol:         null,
      receive_server_name: null,
      receive_user_name:   null,
      receive_password:    null,
      receive_port:        null,
      receive_security:    null,
      receive_spa:         null,
      sent_server_name:    null,
      sent_user_name:      null,
      sent_port:           null,
      sent_password:       null,
      sent_security:       null,
      sent_spa:            null,
      sent_smtp_auth:      null,
      receive_smtp_auth:   null,
      state_flg:           null,
      delete_one_record:       false,
      statusConnection :   '',
      messageConnection: '',

      // Filter Options Search
      receiveusernameSearch: null,
      protcolOptions: [
        "IMAP", "POP3"
      ],
      securityOptions: [
        "なし","SSL/TLS","STARTTLS"
      ],
      spaOptions: [
        "不要","必要"
      ],
      stateOptions: [
        "有効","無効"
      ],
      optionsStateFlg: [
        "有効","無効",'閲覧専用'
      ],
      paginationOptions: [
        10, 20, 30, 50
      ],

      //SortServer
      orderBy: 'id',
      orderDir: 'asc',

      //Pagination
      paginationPageSize: 10,
      pageNumber: 1,
      startRow: 0,
      endRow: 0,

      // AgGrid
      noRowsTemplate: "<span>データがありません</span>",
      domLayout: 'autoHeight',
      gridApi: null,
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridApi.sizeColumnsToFit();
        },
        suppressRowClickSelection: true,

      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        sortingOrder: ['asc', 'desc'],
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'id',
          width: 180,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          sort: 'asc',
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: 'メールサーバ名',
          field: 'mail_srv_name',
          filter: true,
          width: 250,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: 'プロトコル設定',
          field: 'svr_protcol',
          filter: true,
          width: 230,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '受信メールサーバ名 ',
          field: 'receive_server_name',
          filter: true,
          width: 250,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '受信メールアドレス',
          field: 'receive_user_name',
          filter: true,
          width: 250,
          unSortIcon: true,
          suppressMovable: true,
        },
        
        {
          headerName: '受信メールポート番号',
          field: 'receive_port',
          filter: true,
          width: 250,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: '送信メールサーバ名',
          field: 'sent_server_name',
          filter: true,
          width: 250,
          suppressMovable: true,
        },
        {
          headerName: '送信メールアドレス',
          field: 'sent_user_name',
          filter: true,
          width: 250,
          suppressMovable: true,
        },
        {
          headerName: '送信メールポート番号',
          field: 'sent_port',
          filter: true,
          width: 250,
          suppressMovable: true,
        },
        {
          headerName: 'SV連携',
          field: 'is_sv_linked',
          filter: true,
          width: 120,
          unSortIcon: true,
          suppressMovable: true,
          valueFormatter: (params) => {
            return params.value === 1 ? "有効" : "無効";
          }
        },
        {
          headerName: '',
          field: 'transactions',
          width: 170,
          cellRendererFramework: 'CellRendererActions',
          unSortIcon: false,
          suppressMovable: true,
          suppressRowClickSelection: false,
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererActions
      },
      checkTab: 1,
      mail_server_notification: [],
      mail_server_erros: '',
      is_sv_linked: '無効',
    }
  },
  watch: {
    paginationPageSize(val){
      this.setPagination(val);
    },
    'activePopup': function () {
      this.checkTab = 0;
    }
  },
  computed: {
    ...mapGetters({
      getMailServersName: 'mailServer/getMailServersName',
      getUser:            'userManagement/getUser',
      getAllMailServers: 'mailServer/getAllMailServers',
      timeSyncMailServer: 'mailServer/timeSyncMailServer'
    }),
    validateForm(){
      return !this.errors.any()
    },
    mailsData () {
      let mailsData = []
      this.$store.state.mailServer.mailServers.forEach((element) => {
        mailsData.push(Object.assign({
          ...element, svr_protcol : element.svr_protcol == 1 ? 'POP3' : 'IMAP'}));
      });
      return mailsData
    },
    totalPages () {
      return parseInt(this.$store.state.mailServer.infoDB.totalPage)
    },
    totalRow(){
      return parseInt(this.$store.state.mailServer.infoDB.totalRow)
    },
    currentPage: {
      get () {
        return this.pageNumber
      },
      async set (val) {
        this.pageNumber = val
        await this.searchMailWithOrder();
        this.ids = []
        this.gridApi.paginationGoToPage(val-1)
      }
    },
    state(){
      let protcol = null;
      let receivesecurity =null;
      let receivespa = null;
      let sentsecurity =null;
      let sentspa = null;
      let stateflg = null;
      let sentsmtpauth = null;
      let receivesmtpauth = null;
      let state_data = {};
      let isSvLinked = 0;

      if (this.svr_protcol == 'IMAP') this.protcol = 0
      else if (this.svr_protcol =='POP3') this.protcol = 1
      else this.protcol = null

      if (this.receive_security == 'なし') this.receivesecurity = 0
      else if (this.receive_security == 'SSL/TLS') this.receivesecurity = 1
      else if (this.receive_security == 'STARTTLS') this.receivesecurity = 2
      else this.receivesecurity = null

      if (this.receive_spa == '不要') this.receivespa = 0
      else if (this.receive_spa == '必要') this.receivespa = 1
      else this.receivespa = null

      if (this.sent_security == 'なし') this.sentsecurity = 0
      else if (this.sent_security == 'SSL/TLS') this.sentsecurity = 1
      else if (this.sent_security == 'STARTTLS') this.sentsecurity = 2
      else this.sentsecurity = null

      if (this.sent_spa == '不要') this.sentspa = 0
      else if (this.sent_spa == '必要') this.sentspa = 1
      else this.sentspa = null

      if (this.state_flg == '有効') this.stateflg = 1
      else if (this.state_flg == '無効') this.stateflg = 0
      else if (this.state_flg == '閲覧専用') this.stateflg = 2
      
      if (this.sent_smtp_auth == '有効') this.sentsmtpauth = 1
      else if (this.sent_smtp_auth == '無効') this.sentsmtpauth = 0

      if (this.receive_smtp_auth == '有効') this.receivesmtpauth = 1
      else if (this.receive_smtp_auth == '無効') this.receivesmtpauth = 0

      if (this.is_sv_linked == '有効') this.isSvLinked = 1
      else if (this.is_sv_linked == '無効') this.isSvLinked = 0
      
      return state_data = {
        protcol : this.protcol,
        receivesecurity: this.receivesecurity,
        receivespa: this.receivespa,
        sentsecurity: this.sentsecurity,
        sentspa: this.sentspa,
        stateflg: this.stateflg,
        sentsmtpauth : this.sentsmtpauth,
        receivesmtpauth: this.receivesmtpauth,
        isSvLinked: this.isSvLinked,
        }
    }
  },
  methods: {
    ...mapActions({
      fetchMail:      'mailServer/fetchMail',
      fetchMails:      'mailServer/fetchMails',
      deleteMailServers:  'mailServer/deleteMailServers',
      getMailServers: 'mailServer/getMailServers',
      createMailServer:        'mailServer/createMailServer',
      updateMailServer:     'mailServer/updateMailServer',
      testConnection: 'mailServer/testConnection',
    }),
    onSelectionChanged() {
      this.ids = this.gridApi.getSelectedRows().map(mail => mail.id)
    },
    onSortChangedEvent(event){
      let columns = event.columnApi.getAllColumns();
      let root = this;
      columns.forEach(function(column){
        if (column.getSort()){
          root.orderDir = column.getSort()
          root.orderBy  = column.getColId()
          root.searchMailWithOrder();
          return;
        }
      });
    },
    searchMailWithOrder(){
      //fetchMail with condition
      let search = {orderBy: this.orderBy, orderDir: this.orderDir,
      receive_user_name: this.receiveusernameSearch,
      limit: this.paginationPageSize, page: this.pageNumber};
      this.fetchMails(search)
    },
    setUpCreate(){
      // clear all fields before create
      this.mail_srv_name          = null,
      this.svr_protcol            = 'IMAP',
      this.receive_server_name    = null,
      this.receive_user_name      = null,
      this.receive_password       = null,
      this.receive_port           = null,
      this.receive_security       = 'なし',
      this.receive_spa            = '不要',
      this.sent_server_name       = null,
      this.sent_user_name         = null,
      this.sent_port              = null,
      this.sent_password          = null,
      this.sent_security          = 'なし',
      this.sent_spa               = '不要',
      this.state_flg              = '有効',
      this.sent_smtp_auth         = '無効',
      this.receive_smtp_auth      = '無効',
      this.submited               = false,
      this.title                  = 'メールサーバー情報登録',
      this.activePopup            = true,
      this.messageConnection      = '',
      this.statusConnection       = '',
      this.mail_server_notification = [],
      this.is_sv_linked           = '無効'
    },
    async actionTestConnection(){
      let check_receive_security = ''
      let check_sent_security = ''
      if (this.receive_security == 'SSL/TLS') check_receive_security = 'ssl'
      if (this.receive_security == 'STARTTLS') check_receive_security = 'tls'
      if (this.sent_security == 'SSL/TLS') check_sent_security = 'ssl'
      if (this.sent_security == 'STARTTLS') check_sent_security = 'tls'
      let check = {
          //Receive
          receive_server_name:        this.receive_server_name,
          receive_port:               parseInt(this.receive_port),
          receive_security:           check_receive_security,
          receive_user_name:          this.receive_user_name,
          receive_password:           this.receive_password,
          //Sent
          sent_server_name:           this.sent_server_name,
          sent_port:                  parseInt(this.sent_port),
          sent_security:              check_sent_security,
          sent_user_name:             this.sent_user_name,
          sent_password:              this.sent_password,
          //
          svr_protcol:                this.svr_protcol,
      }

      const testConnectionResponseMsg = await this.testConnection(check);
      this.messageConnection = "";
      if (testConnectionResponseMsg === true){
        this.statusConnection = true;
        this.messageConnection = '接続確認に成功しました。';
      }
      else{
        this.statusConnection = false;
        this.messageConnection = '接続確認に失敗しました。\n' + testConnectionResponseMsg;
      }
    },

    async actionCreate(){
      if(!this.validateForm){
        this.submited = true; // first: no show error => after submited: show error
      }
      else{
        let mail = {
          mail_srv_name:              this.mail_srv_name,
          svr_protcol:                this.state.protcol,
          receive_server_name:        this.receive_server_name,
          receive_user_name:          this.receive_user_name,
          receive_password:           this.receive_password,
          receive_port:               parseInt(this.receive_port),
          receive_security:           this.state.receivesecurity,
          receive_spa:                this.state.receivespa,
          sent_server_name:           this.sent_server_name,
          sent_user_name:             this.sent_user_name,
          sent_port:                  parseInt(this.sent_port),
          sent_password:              this.sent_password,
          sent_security:              this.state.sentsecurity,
          sent_spa:                   this.state.sentspa,
          state_flg:                  this.state.stateflg,
          sent_smtp_auth:             this.state.sentsmtpauth,
          receive_smtp_auth:          this.state.receivesmtpauth,
          mail_server_notification:   [],
          is_sv_linked:               0,
        }
        
       if (await this.createMailServer(mail)) {
          this.activePopup = false
          await this.searchMailWithOrder()
       }  
      }
    },
    checkValidateMail(listMail){
        const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        const validationResult = listMail.reduce((result, item, index) => {
          if (!item.name) {
            let msgEmpty = `通知メールアドレス-番号 ${index + 1} は入力してくだい。`;
            this.$vs.notify({
              position: 'bottom-right',
              text: msgEmpty,
              color: 'danger'
            })
            result.errors.push(`通知メールアドレス-番号 ${index + 1} は必須です。`)
          } else if (!emailRegex.test(item.name)) {
            let msgInvalid = `通知メールアドレス-番号 ${index + 1} の形式は正しくありません。`;
            this.$vs.notify({
              position: 'bottom-right',
              text: msgInvalid,
              color: 'danger'
            })
            result.errors.push(`通知メールアドレス-番号 ${index + 1} の形式は正しくありません。`)
          } else if (listMail.filter(i => i.name === item.name).length > 1) {
            let msgDuplicate = `通知メールアドレス-番号 ${index + 1} すでに使われています。`;
            this.$vs.notify({
              position: 'bottom-right',
              text: msgDuplicate,
              color: 'danger'
            })
            result.errors.push(`通知メールアドレス-番号 ${index + 1} すでに使われています。`)
          }
          return result
        }, { errors: [] })
        return { validationResult };
    },
    async actionUpdate(){
        let isNullValid = this.mail_server_notification.every(item => item.name !== '');
        if(this.mail_server_notification.length == 1 && !isNullValid){
          this.mail_server_notification = [];
        } else {
          const { validationResult } = this.checkValidateMail(this.mail_server_notification);
          if(validationResult.errors.length > 0){
            return;
          }
        }

        if (await this.updateMailServer(
            {
              id:                         this.id,
              mail_srv_name:              this.mail_srv_name,
              svr_protcol:                this.state.protcol,
              receive_server_name:        this.receive_server_name,
              receive_user_name:          this.receive_user_name,
              receive_password:           this.receive_password,
              receive_port:               parseInt(this.receive_port),
              receive_security:           this.state.receivesecurity,
              receive_spa:                this.state.receivespa,
              sent_server_name:           this.sent_server_name,
              sent_user_name:             this.sent_user_name,
              sent_port:                  parseInt(this.sent_port),
              sent_password:              this.sent_password,
              sent_security:              this.state.sentsecurity,
              sent_spa:                   this.state.sentspa,
              state_flg:                  this.state.stateflg,
              sent_smtp_auth:             this.state.sentsmtpauth,
              receive_smtp_auth:          this.state.receivesmtpauth,
              mail_server_notification:   Array.from(new Set(this.mail_server_notification.map(item => item.name))),
              is_sv_linked:               this.state.isSvLinked,
          })){
            this.activePopup = false
            this.ids = []
            await this.searchMailWithOrder()
          }
    },
    addMailServerNotification() {
      if(this.mail_server_notification.length >= 10){
       let msgErrors = '通知メールアドレスは最大10件しか設定されないため、ご確認下さい。';
        this.$vs.notify({
            position: 'bottom-right',
            text: msgErrors,
            color: 'danger'
          })
          return;
      }
      this.mail_server_notification.push({name: '' });
    },
    handleFocusNotification(index){
      this.mail_server_erros = index;
    },
    handleBlurNotification(index){
      if(this.mail_server_notification.length > 0) {
        let nameValue = this.mail_server_notification[index].name;
        const duplicates = this.mail_server_notification.filter((item, i) => item.name === nameValue);
        if(duplicates.length > 0 ){
          this.mail_server_erros = index;
        }else{
          this.mail_server_erros = '';
        }
      }
    },
    removeMailServerNotification(index) {
      this.mail_server_notification.splice(index, 1);
    },
    async confirmDelete(){
      await this.deleteSelect();
      this.activeDelete = false
      this.activePopup = false
    },
    async deleteSelect () {
      await this.deleteMailServers(this.ids)
      this.gridApi.deselectAll()
      this.ids = []
      await this.searchMailWithOrder()
    },
    async resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()
      this.receiveusernameSearch= null,
      this.ids = []
      await this.searchMailWithOrder()
      this.$refs.filterCard.removeRefreshAnimation()
    },
    async setPagination(val){
      this.gridApi.paginationSetPageSize(val);
      this.pageNumber = 1
      await this.searchMailWithOrder();
      this.ids = []
    },
    editListener(id) {
      this.fetchMail(id)
        .then(mail => {
          this.id                   =      mail.mail_detail.id
          this.mail_srv_name        =      mail.mail_detail.mail_srv_name  
          this.receive_server_name  =      mail.mail_detail.receive_server_name
          this.receive_user_name    =      mail.mail_detail.receive_user_name
          this.receive_password     =      mail.mail_detail.receive_password
          this.receive_port         =      mail.mail_detail.receive_port
          this.sent_server_name     =      mail.mail_detail.sent_server_name
          this.sent_user_name       =      mail.mail_detail.sent_user_name
          this.sent_port            =      mail.mail_detail.sent_port
          this.sent_password        =      mail.mail_detail.sent_password
          this.title        = 'メールサーバー情報更新'
          if (mail.mail_detail.svr_protcol == 0) this.svr_protcol = 'IMAP'
          if (mail.mail_detail.svr_protcol == 1) this.svr_protcol = 'POP3'
          if (mail.mail_detail.svr_protcol == 0) this.receive_security = 'なし'

          if (mail.mail_detail.receive_security == 0) this.receive_security = 'なし'
          if (mail.mail_detail.receive_security == 1) this.receive_security = 'SSL/TLS'
          if (mail.mail_detail.receive_security == 2) this.receive_security = 'STARTTLS'

          if (mail.mail_detail.receive_spa == 0) this.receive_spa = '不要'
          if (mail.mail_detail.receive_spa == 1) this.receive_spa = '必要'

          if (mail.mail_detail.sent_security == 0) this.sent_security = 'なし'
          if (mail.mail_detail.sent_security == 1) this.sent_security = 'SSL/TLS'
          if (mail.mail_detail.sent_security == 2) this.sent_security = 'STARTTLS'

          if (mail.mail_detail.sent_spa == 0) this.sent_spa = '不要'
          if (mail.mail_detail.sent_spa == 1) this.sent_spa = '必要'

          if (mail.mail_detail.state_flg == 0) this.state_flg = '無効'
          if (mail.mail_detail.state_flg == 1) this.state_flg = '有効'
          if (mail.mail_detail.state_flg == 2) this.state_flg = '閲覧専用'
          
          if (mail.mail_detail.sent_smtp_auth == 0) this.sent_smtp_auth = '無効'
          if (mail.mail_detail.sent_smtp_auth == 1) this.sent_smtp_auth = '有効'

          if (mail.mail_detail.receive_smtp_auth == 0) this.receive_smtp_auth = '無効'
          if (mail.mail_detail.receive_smtp_auth == 1) this.receive_smtp_auth = '有効'
          this.messageConnection      = ''
          this.statusConnection       = ''
          this.submited     = true
          this.activePopup  = true
          this.mail_server_notification = mail.mail_detail.mail_server_notification ? mail.mail_detail.mail_server_notification.split(',').map(item => ({name: item.trim()})) : [{name: '' }]
          if (mail.mail_detail.is_sv_linked == 0) this.is_sv_linked = '無効'
          if (mail.mail_detail.is_sv_linked == 1) this.is_sv_linked = '有効'
      })
    },
    deleteListener(id) {
      this.ids = [id];
      this.fetchMail(id)
        .then(mail => {
          this.mail_srv_name        =      mail.mail_detail.mail_srv_name  
          this.receive_server_name  =      mail.mail_detail.receive_server_name
          this.receive_user_name    =      mail.mail_detail.receive_user_name
          this.sent_server_name     =      mail.mail_detail.sent_server_name
          this.sent_user_name       =      mail.mail_detail.sent_user_name
      })
      this.delete_one_record = true
      this.activeDelete = true
    },
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
    EventBus.$on('editRecord', this.editListener);
    EventBus.$on('deleteRecord', this.deleteListener);
    
    // save paginationSize to sessionStorage (when fresh browser)
    const root = this
    window.addEventListener('beforeunload', function(){
      sessionStorage.setItem("paginationPageSize", root.paginationPageSize)
    })
  },
  async created () {
    await this.searchMailWithOrder();
  },
  beforeMount(){
    // set page after load (change route = 10, refresh = save PaginationSize in SessionStorage )
    let paginationPageSize = sessionStorage.getItem("paginationPageSize");
    if (paginationPageSize !== null) this.paginationPageSize = paginationPageSize
  },
  updated(){
    // set paginationPageSize = 10 (default) when change page/route
    sessionStorage.setItem("paginationPageSize", 10)
    // calc number startRow and endRow
    this.$nextTick(()=>{
      if(!this.$store.state.loading && this.mailsData.length > 0){
        this.startRow = this.pageNumber * this.paginationPageSize - this.paginationPageSize + 1
        if(this.mailsData.length == this.paginationPageSize) this.endRow = this.pageNumber*this.paginationPageSize
        else this.endRow = this.paginationPageSize*this.pageNumber + this.mailsData.length - this.paginationPageSize
      }
      if(this.mailsData.length == 0){
        this.endRow = 0
        this.startRow = 0
      }
    });
  },
  beforeDestroy(){
    EventBus.$off('editRecord', this.editListener);
    EventBus.$off('deleteRecord', this.deleteListener);
  },
  destroyed(){
    // hiden popup while edit/update => click back/next on broswer (use activePopup = false not working)
    document.getElementById('dialogDelete').style.display = 'none'
    document.getElementById('dialogUpdate').style.display = 'none'
    document.getElementById('dialogSync').style.display = 'none'

  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/view/mailServer.scss";
  .icon-custom .vs-button-text {
    display: flex;
    align-items: center;

    svg {
      margin-right: 7px;
    }
  }
  .vs-button-text {
    display: flex;
  }
  .vs-button-text svg {
    margin-right: 5px;
    margin-top: 1px;
  }
  .vs-button-customs {
    padding: 8px !important; 
    margin-right: 5px !important;
    height: 37px !important;
  }
  .card-mail-serve {
    font-size: 12px;
    .vx-card__collapsible-content .vx-card__body {
      padding-top: 1rem;
      padding-bottom: 0.5rem;
    }
  }
  .checkTabOne {
    .con-vs-tabs .con-ul-tabs, .vs-tabs--ul {
      display: none;
    }
  }
</style>
